export const SyncActionDefinition = {
  "site": {
    "list": "0",
    "group": "1",
    "load": "2",
    "update": "3"
  },
  "comp": {
    "new": "4",
    "list": "5",
    "group": "6",
    "load": "7"
  },
  "page": {
    "list": "8",
    "load": "9",
    "cache": "10"
  },
  "yjs": {
    "um": "11",
    "sv_local": "12",
    "diff_local": "13",
    "sv_remote": "14"
  },
  "client": {
    "info": "15"
  },
  "code": {
    "load": "16",
    "edit": "17",
    "action": "18"
  }
};
export const SyncActionPaths = {
  "0": "site.list",
  "1": "site.group",
  "2": "site.load",
  "3": "site.update",
  "4": "comp.new",
  "5": "comp.list",
  "6": "comp.group",
  "7": "comp.load",
  "8": "page.list",
  "9": "page.load",
  "10": "page.cache",
  "11": "yjs.um",
  "12": "yjs.sv_local",
  "13": "yjs.diff_local",
  "14": "yjs.sv_remote",
  "15": "client.info",
  "16": "code.load",
  "17": "code.edit",
  "18": "code.action"
};
